export default function(amount, current, ratio = 0.7 ) {
    return ratio + (.45 * Math.abs(amount - current))
}